export enum Type {
    APP = 'app',
    SO = 'os'
}
export enum Flags {
    'NEW'= 'NEW',
    'USER' = 'USER',
    'DEPRECATED' = 'DEPRECATED'
}

export enum TemplateStatus{
    CREATING = 'CREATING',
    ACTIVE = 'ACTIVE'
}

export enum ShortName {
    bitnami = "bitnami",
    cassandra = "cassandra",
    centos = "centos",
    cpanel = "cpanel",
    erpnext = "erpnext",
    ico_barcode = "ico_barcode",
    jenkins = "jenkins",
    joomla = "joomla",
    magento = "magento",
    mariadb = "mariadb",
    mattermost = "mattermost",
    mean = "mean",
    mediawiki = "mediawiki",
    memcached = "memcached",
    mongodb = "mongodb",
    moodle = "moodle",
    multicraft = "multicraft",
    mysql = "mysql",
    nginx = "nginx",
    odoo = "odoo",
    phpbb = "phpbb",
    plesk = "plesk",
    postgresql = "postgresql",
    prestashop = "prestashop",
    redhat = "redhat",
    redis = "redis",
    sqlserver = "sqlserver",
    sugar = "sugar",
    tomcat = "tomcat",
    ubuntu = "ubuntu",
    windows = "windows",
    wordpress = "wordpress",
    rocky = "rocky",
    alma = "alma",
    debian = "debian"
}

export interface Template {
    id?:string
    name?: string // retornar nome do template ou null
    description?: string // retornar descrĩção do template ou null
    creationDate?: string // data de criação do template '1970-01-01T00?:00?:00.000Z'
    status?: TemplateStatus //essa ainda não sei dizer quais status vamos tratar, não vamos utilziar na tela de marketplace neste momento // mas a príncipio seriam esses (CREATING,ACTIVE,ERROR, CANCELED,PURGED)
    image?:Image,
    actions?:{
        cancel?:boolean
    }
}

export interface Image {
    id:string
    type?: Type // 'app ou so'
    flags?: Flags[]|null //array de flags, até o momento espero receber 'NW' para novas imagens e 'USER' para templates customizados
    minRequirements?: { // requerimentos mínimo de hardware para instalar o template
        disk?: number // quantidade de disco em GB
        vcpu?: number //quantidade de vcpu
        memory?: number //quantidade de memória em MB
    }
    template?: Template | null
    operationalSystem?: { //o sistema operacional da imagem, este objeto sempre virá preenchido
        name?: string // nome do sistema operacional, acho que as únicas opções são Windows Server e Ubuntu Server e CentOS
        shortName?:ShortName //usar o campo icon da api
        version?: string // versão do SO, exemplos?: 16.04 LTS (para ubuntu), 2008 R2 (para windows), 6.5 (para o CentOS)
        arch?: number // deve retornar 32 ou 64
        price?:{
            unitPrice?: number //valor da licença, exemplo de formato?: 20.00, caso seja incluso retornar 0
            chargeType?: 'FLAT' | 'VCPU' //'FLAT ou VCPU'
        }
    }
    application?: { //retornar os campos abaixo como nulo, caso ele não seja uma imagem
        name?:string //retornar nome da aplicação ex?: Wordpress, Cassandra, Jenkins etc
        shortName?:ShortName //usar o campo icon da api
        version?:string  //ex?: 1.31.1
        link?: string //link para acessar a imagem
        price?:{
            unitPrice?: number //'20.00 ou 0'
            chargeType?: string //'FLAT ou VCPU'
        }
    } | null
}

export interface Actions {
    start?: boolean,
    changePlan?: boolean,
    changeImage?: boolean,
    upgrade?: boolean,
    stop?: boolean,
    reboot?: boolean,
    detachDisk?: boolean,
    attachDisk?: boolean,
    accessConsole?: boolean,
    viewBooklet?: boolean,
    accessTemplate?: boolean,
    cancel?: boolean,
    templateCreate?: boolean,
    networkCreate?: boolean,
    createTemplate?: boolean,
    migrationCompleted?: boolean,
    marketplaceServiceActivation?: boolean,
}

export enum Status {
    RUNNING = 'RUNNING',
    STOPPED = 'STOPPED',
    STARTING = 'STARTING',
    STOPPING = 'STOPPING',
    REBOOTING = 'REBOOTING',
    STUCK = 'STUCK',
    CONFIGURING = 'CONFIGURING',
    WAITING_PAYMENT = 'WAITING_PAYMENT',
    WAITING_SMS = 'WAITING_SMS',
    PROVISIONING = 'PROVISIONING',
    CHANGING_PLAN = 'CHANGING_PLAN',
    SNAPSHOT_CREATED = 'SNAPSHOT_CREATED',
    CREATING_SNAPSHOT = 'CREATING_SNAPSHOT',
    SNAPSHOT_CREATION_FAILED = 'SNAPSHOT_CREATION_FAILED',
    RESTORING_SNAPSHOT = 'RESTORING_SNAPSHOT',
    SNAPSHOT_RESTORED = 'SNAPSHOT_RESTORED',
    DELETING_SNAPSHOT = 'DELETING_SNAPSHOT',
    SNAPSHOT_DELETED = 'SNAPSHOT_DELETED',
    SNAPSHOT_DELETE_FAILED = 'SNAPSHOT_DELETE_FAILED',
    CREATING_TEMPLATE = 'CREATING_TEMPLATE',
    TEMPLATE_CREATED = 'TEMPLATE_CREATED',
    TEMPLATE_INSTALLING = 'TEMPLATE_INSTALLING',
    TEMPLATE_INSTALLED = 'TEMPLATE_INSTALLED',
    TEMPLATE_DELETED = 'TEMPLATE_DELETED',
    DELETING_TEMPLATE = 'DELETING_TEMPLATE',
    TEMPLATE_DELETE_FAILED = 'TEMPLATE_DELETE_FAILED',
    DEFAULTER = 'DEFAULTER',
    BLOCKED = 'BLOCKED'
}

export enum PlanBillingType {
    MENSAL = 'MENSAL',
    FRACIONADA = 'FRACIONADA',
    GRATUITA = "GRATUITA"
}

export enum PlanBillingPlatform {
    PLATAFORMA = 'PLATAFORMA',
    CLOUDMETER = 'CLOUDMETER'
}

export interface Plan {
    billingPlatform?: PlanBillingPlatform,
    billingType?: PlanBillingType
    purchaseDate?: Date
    name?: string
}

export enum PaymentMethod {
    BOOKLET = 'BOOKLET',
    CREDIT_CARD = 'CREDIT_CARD'
}

export interface PublickAddress {
    address?:string
    native?:Boolean
    firewall?: {
        status:'ON'|'OFF'
    }
}

export interface Server {
    id?:string
    codServer?: string
    actions?:Actions
    name?: string
    status?:Status
    plan?: Plan
    payment?:{
        method?: PaymentMethod
        url?: string
    }
    image?: Image
    hardware?: Hardware
    publicAddresses?:PublickAddress[]
    privateAddresses?:[string]
    authentication?:{
        username?:string
        password?:string
    }
    marketplace?: Marketplace[]
}

export interface Hardware {
    vcpu?: number 
    memory?: number
    disk?: number
    bandwidth?: number
}

export interface Compute {
    hardware: {
    disk: number,
    vCpu: number,
        memory: number,
        bandwidth: number
    },
    price: number,
    discount:{
        value:number,
        monthDuration:number
    }
    diskAvailable: {
        min: number,
        max: number
    },
    bandwidthAvailable: {
        min: number,
        max: number
    }
}

export interface Disk {
    sizes: number[]
    price: number
}

export interface Bandwidth {
    sizes: number[],
    price: number
}
export interface Profiles{
    products: {
        group: "G3",
        computes: Compute[],
        disks: Disk,
        bandwidths: Bandwidth
    }
}

export enum MarketplaceList{
    'monitoring'='WEBPROS360MONITORING'
}

export type MarketplaceStatus = 'ACTIVE' | 'DISABLED'

export interface Marketplace {
    name:MarketplaceList
    status:MarketplaceStatus
}
